import { render, staticRenderFns } from "./BrandDescribeEdit.vue?vue&type=template&id=6ae379cd"
import script from "./BrandDescribeEdit.vue?vue&type=script&lang=js"
export * from "./BrandDescribeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports